import {Outlet} from "react-router";
import Header from "@/Header.tsx";
import OverlayModal from "@/modal/OverlayModal.tsx";
import {NuqsAdapter} from "nuqs/adapters/react-router/v7";

function Layout() {
    return <div className="flex h-full flex-col bg-background">
        <OverlayModal/>
        <Header/>
        <NuqsAdapter>
        <Outlet/>
        </NuqsAdapter>
    </div>
}

export default Layout
